import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=0ba2349e&scoped=true"
import script from "./PageSection.vue?vue&type=script&lang=ts"
export * from "./PageSection.vue?vue&type=script&lang=ts"
import style0 from "./PageSection.vue?vue&type=style&index=0&id=0ba2349e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba2349e",
  null
  
)

export default component.exports